class GlobalTimerManager {
  private activeTimeouts = new Set<any>();
  private activeIntervals = new Set<any>();

  private nativeSetTimeout = window.setTimeout;
  private nativeClearTimeout = window.clearTimeout;
  private nativeSetInterval = window.setInterval;
  private nativeClearInterval = window.clearInterval;

  init() {
    // Intercept setTimeout
    window.setTimeout = ((handler: TimerHandler, timeout?: number, ...args: any[]): number => {
      const id = this.nativeSetTimeout(() => {
        this.activeTimeouts.delete(id);
        if (typeof handler === 'function') {
          handler(...args);
        } else {
          eval(handler);
        }
      }, timeout);
      this.activeTimeouts.add(id);
      return id;
    }) as any;

    // Intercept clearTimeout
    window.clearTimeout = (id: any) => {
      this.activeTimeouts.delete(id);
      this.nativeClearTimeout(id);
    };

    // Intercept setInterval
    window.setInterval = ((handler: TimerHandler, timeout?: number, ...args: any[]): number => {
      const id = this.nativeSetInterval(handler, timeout, ...args);
      this.activeIntervals.add(id);
      return id;
    }) as any;

    // Intercept clearInterval
    window.clearInterval = (id: any) => {
      this.activeIntervals.delete(id);
      this.nativeClearInterval(id);
    };
  }

  /**
   * Clear all active global timers simultaneously
   */
  clearAll() {
    this.activeTimeouts.forEach(id => this.nativeClearTimeout(id));
    // show actime timeouts in console for debugging
    console.log('Clearing all active timeouts:', Array.from(this.activeTimeouts));
    this.activeTimeouts.clear();

    this.activeIntervals.forEach(id => this.nativeClearInterval(id));
    // show active intervals in console for debugging
    console.log('Clearing all active intervals:', Array.from(this.activeIntervals));
    this.activeIntervals.clear();
  }
}

export const globalTimerManager = new GlobalTimerManager();
